"use client";

import { useParams, usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import {
  getSessionStorageItem,
  removeSession,
  setSessionStorageItem,
} from "@/utils/common/sessionStorageItemHelper/sessionStorageItemUtils";
import { SessionStorageItemEnum } from "@/utils/enums/SessionStorageItemEnum";

import LoadingGother from "../Loading/LoadingGother";

const ReloadPageComponent = () => {
  const refresh403Page = SessionStorageItemEnum.hasRefreshed403Page;
  const { slug } = useParams() as { slug: string };
  const pathname = usePathname();
  const [isShowError, setIsShowError] = useState(false);

  useEffect(() => {
    const hasRefreshed = getSessionStorageItem(refresh403Page);

    if (!hasRefreshed) {
      setSessionStorageItem(refresh403Page, "true");
      window.location.reload();
    } else {
      removeSession(refresh403Page); // Reset for future errors
      setIsShowError(true);
    }
  }, []);

  if (isShowError) {
    window.location.href = "/";
  }

  return (
    <div className="flex h-screen items-center justify-center">
      <LoadingGother
        isOverlay={false}
        className="flex h-6 w-full items-center justify-center overflow-hidden"
        imageClass="w-full max-w-[500px]"
      />
    </div>
  );
};

export default ReloadPageComponent;
